import React from 'react';
import { GET_TOTAL_WORKPLACES_VERIFIED_ENDPOINT } from '../../types/AnalyticsApi';
import CrossSectionalData from '../../types/CrossSectionalData';
import { WorkplacesOptions, DataProviderOptions } from '../../types/DataProvider';
import DataProvider, { OptionalDataProviderProps } from './DataProvider';

interface WorkplacesDataProviderProps extends OptionalDataProviderProps {
    children: any;
    options?: WorkplacesOptions;
    crossSection?: boolean;
}
const WorkplacesDataProvider: React.FC<WorkplacesDataProviderProps> = ({
    children,
    options,
    crossSection,
    ...other
}) => {
    const crossSectionalResponseHandler = (res: any, options: DataProviderOptions): CrossSectionalData => {
        let crossSectionalData: CrossSectionalData = [];

        crossSectionalData.push({
            key: 'all',
            value: res.data
        });

        return crossSectionalData;
    };

    return (
        <DataProvider
            dataFormat={'CROSS_SECTION'}
            src={GET_TOTAL_WORKPLACES_VERIFIED_ENDPOINT}
            options={options}
            responseHandler={crossSectionalResponseHandler}
            updateOnEventStrings={['COMPANY_VERIFICATION_STATUS_UPDATED']}
            {...other}
        >
            {children}
        </DataProvider>
    );
};

export default WorkplacesDataProvider;
